var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.pictures),function(pic,i){return _c('PreviewImage',{key:i,staticClass:"mr-1",attrs:{"src":pic.picture}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }